require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-institution-banco-asiatico-de-inversion-en-infraestructura.json") })
        }
      }, "path---es-mx-institution-banco-asiatico-de-inversion-en-infraestructura");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-institution-banco-asiatico-de-inversion-en-infraestructura!./.cache/json/es-mx-institution-banco-asiatico-de-inversion-en-infraestructura.json
// module id = 890
// module chunks = 231608221292675